import { render, staticRenderFns } from "./PixabayImagePreview.vue?vue&type=template&id=4956658f&scoped=true"
import script from "./PixabayImagePreview.vue?vue&type=script&lang=js"
export * from "./PixabayImagePreview.vue?vue&type=script&lang=js"
import style0 from "./PixabayImagePreview.vue?vue&type=style&index=0&id=4956658f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4956658f",
  null
  
)

export default component.exports